import styled from '@emotion/styled'
import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { ExploreDimData, ExploreFormData, MappedName } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { normalizeAsTrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { WidgetProps } from '~/components/Widget'
import { AnalyticsBreakdownObj, useAnalyticsBreakdownObj } from '~/modules/analytics/AnalyticsBreakdownObj'
import { AnalyticsDataTableConfigs } from '~/modules/analytics/analyticsDataTableObj.hooks'
import { ExploreFormulasConfig } from '~/modules/analytics/explore/explore'
import { WithClassName } from '~/types/utils'

type PureExploreBreakdownWidgetProps = WithClassName &
  Omit<WidgetProps, 'title' | 'info' | 'icon' | 'refreshTrackingLabel'> & {
    onRowClick: (name: MappedName) => void
    onSortChange: (metric: string) => void
    rawData?: ExploreDimData<any>
    formData: ExploreFormData
    currencySymbol: CurrencySymbol
    exploreFormulasConfig: ExploreFormulasConfig
  }
const UnstyledPureExploreBreakdownWidget: FunctionComponent<PureExploreBreakdownWidgetProps> = ({ rawData, formData, currencySymbol, exploreFormulasConfig, ...props }) => {
  const metricNames = formData.metrics.map((metric) => Object.entries(exploreFormulasConfig).find(([, { formula }]) => formula.name === metric)?.[0] ?? '')

  const breakdownProps = useAnalyticsBreakdownObj<any>({
    rawData,
    currencySymbol,
    onTabChange: () => {},
    getColumnsConfigs: () => metricNames,
    getConfigs: () =>
      [
        [
          {
            displayedAs: 'text',
            sortLabel: 'Site name',
          },
          ...metricNames.map((metricName) => {
            const notApplicableDimension = (exploreFormulasConfig[metricName]?.dimensionNotApplicable || []).includes(formData.dimension as Dimension)
            return {
              propertyName: metricName,
              formula: exploreFormulasConfig[metricName].formula,
              tooltip: exploreFormulasConfig[metricName].formula.tooltip,
              isComputable: () => !notApplicableDimension,
            }
          }),
        ],
      ] as AnalyticsDataTableConfigs<any>,
    tabsConfig: [{ dimension: formData.dimension as Dimension, label: '', iconName: 'empty', trackingLabel: `ana-explore-breakdown-${normalizeAsTrackingLabel(formData.dimension)}-tab-apply` }],
  })
  return <AnalyticsBreakdownObj {...props} {...breakdownProps} refreshTrackingLabel={'ana-explore-breakdown-refresh'} />
}
export const PureExploreBreakdownWidget = styled(UnstyledPureExploreBreakdownWidget)``
